<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 lg4 xl3>
        <UpdateProfile />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UpdateProfile from '../components/UpdateProfile';

export default {
  components: {
    UpdateProfile,
  },

  metaInfo: {
    title: 'Update Profile',
  },
};
</script>
